export const FETCH_NOTIFY = 'FETCH_NOTIFY';
export const FETCH_NOTIFY_SUCCEED = 'FETCH_NOTIFY_SUCCEED';
export const FETCH_NOTIFY_FAILED = 'FETCH_NOTIFY_FAILED';
